import React, {FC, ReactElement} from 'react';
import './index.scss'
import ArrowIcon from './arrow.svg';
import {IServiceItemProps} from "./type";
import {Popover} from "antd";
import {convertToArray, getLinkRow} from "mixins/helpers";

const ServiceItem: FC<IServiceItemProps> = (props: IServiceItemProps) => {
    const routeToLink = (url: string) => {
        if (url) {
            if (props.isExternal) {
                open(url);
            } else {
                window.location.href = `/${props.language}${url}`;
            }
        }
    };

    const getLinks = (links: any[]): ReactElement => {
        let node = null;

        links.forEach(x => {
            node = getLinkRow(x.title, x.link, node)
        });

        return node;
    };

    return (
        props.is_context ? (
            <Popover placement="bottomRight" content={getLinks(convertToArray(props.links))}>
                <div className="service-link">
                    <div>{ props.name }</div>

                    <div>
                        <ArrowIcon />
                    </div>
                </div>
            </Popover>
        ) : (
        <div className={`service-link ${props.position}`} onClick={() => routeToLink(props.url)}>
            {props.name}

            <div>
                <ArrowIcon />
            </div>
        </div>
        )
    )
};

export default ServiceItem;
